import {
  initialConsentState,
  SIGN_CONSENT,
  UPDATE_CONSENT_TEXT,
  UPDATE_CONSENT_PATIENTS,
  RESET_CONSENT_STATE,
} from './constants'

export const consentReducer = (
  state: ConsentState = initialConsentState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): ConsentState => {
  switch (action.type) {
    case UPDATE_CONSENT_TEXT:
      return {
        ...state,
        consentText: action.payload,
      }
    case SIGN_CONSENT:
      return {
        ...state,
        isConsentSigned: action.payload,
      }

    case UPDATE_CONSENT_PATIENTS:
      return {
        ...state,
        patients: action.payload,
      }
    case RESET_CONSENT_STATE:
      return initialConsentState
    default:
      return state
  }
}
